// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"82cd36673bca8bf8","3899":"17c2d8095c70a73a"}[chunkId] + ".js";
};